import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { TppAccount, TppAccountsPagination } from "src/app/shared/models/tpp-account.interface";
import { environment as env } from "@environments/environment";

@Injectable({
	providedIn: "root"
})
export class TppAccountsService {
	private http: HttpClient = inject(HttpClient);

	searchTPPAccountsByTppServiceId(serviceId: string, pageNumber: number, pageSize: number): Observable<TppAccount[]> {
		return this.searchTPPAccounts([], [], serviceId, pageNumber, pageSize);
	}

	searchTPPAccounts(
		countries: string[],
		currencies: string[],
		services: string,
		pageNumber: number,
		pageSize: number
	): Observable<TppAccount[]> {
		let params = new HttpParams();
		params = params.append("countries", countries.toString());
		params = params.append("currencies", currencies.toString());
		params = params.append("services", services);
		params = params.append("pageSize", pageSize.toString());
		params = params.append("pageNumber", pageNumber.toString());
		return this.http
			.get<TppAccountsPagination>(`${env.apiUri}/v1/accounts/tpp`, { params })
			.pipe(map((response: TppAccountsPagination) => response.items));
	}
}
